import * as React from 'react';
import { useResponsiveImageView } from './useResponsiveImageView';
function defaultOnLoad() {}
function defaultOnError(_) {}
function isFunctionComponent(ComponentOrFunction) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return !ComponentOrFunction.prototype.isReactComponent;
}
function ResponsiveImageView(_ref) {
  let {
    component: ComponentOrFunction = undefined,
    render = undefined,
    children = undefined,
    aspectRatio = undefined,
    source,
    onLoad = defaultOnLoad,
    onError = defaultOnError
  } = _ref;
  const bag = useResponsiveImageView({
    aspectRatio,
    source,
    onLoad,
    onError
  });

  // component injection
  if (ComponentOrFunction) {
    // function component
    if (isFunctionComponent(ComponentOrFunction)) {
      return ComponentOrFunction(bag);
    }

    // class component
    return /*#__PURE__*/React.createElement(ComponentOrFunction, bag);
  }

  // render prop
  if (typeof render === 'function') {
    return render(bag);
  }

  // function-as-children
  if (typeof children === 'function') {
    return children(bag);
  }

  // no renderer provided, but children exist - just render the children as-is
  if (children && React.Children.count(children) > 0) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, React.Children.only(children));
  }
  return null;
}
ResponsiveImageView.displayName = 'ResponsiveImageView';
export { useResponsiveImageView };
export default ResponsiveImageView;
//# sourceMappingURL=index.js.map